export interface RingingDevice {
    ringing(): void;
    stop(): void;
    tag: string;
}

export class BasicRingingDevice implements RingingDevice {
    private audio: HTMLAudioElement;
    public tag: string;

    constructor(mp3Source: string, tag: string) {
        this.audio = new Audio(mp3Source);
        this.audio.loop = true;
        this.audio.muted = false;
        this.tag = tag;
    }

    async ringing() {
        await this.audio.play();
    }

    stop() { this.audio.pause(); }
}
